import styled from '@emotion/styled';
import { Magnetic as Mi } from "../../../styles";
import { Grid, ListItem } from '@material-ui/core';
import { Button } from "../../button";
import { css } from '@emotion/core';
import { GROUP_NAME_PADDING_LEFT } from '../constants';
export const StyledMenu = styled('div') `
	max-height: ${(props) => props.shouldScroll && !props.issticky ? Mi.layoutBreakpointXs : 'none'};
	overflow: auto;
`;
export const StyledGroupName = styled('span') `
	color: ${Mi.colorNeutral50};
	cursor: ${Mi.disabledCursor};
	padding-left: ${GROUP_NAME_PADDING_LEFT};
`;
export const StyledListItemIcon = styled('span') `
	margin-right: ${Mi.spacer08};
	width: ${Mi.spacer16};
	color: ${(props) => props.leftIconColor ? props.leftIconColor : Mi.colorBlack};
`;
export const StyledSplitGrid = styled(Grid) `
	position: relative;
	width: 100%;
	height: 100%;
	direction: row;
	justify-content: space-between;
	align-items: center;
`;
export const StyledButton = styled(Button) `
	margin: ${Mi.spacer08};
`;
export const SelectedSortItem = css `
	background-color: ${Mi.menuItemSelectedBackgroundColor};
	color: ${Mi.menuItemSelectedColor};
	cursor: ${Mi.disabledCursor};
	position: relative;
	font-size: ${Mi.fontSize14};
	.right-sort > span {
		margin: 0 0 0 ${Mi.spacer04};
	}
`;
export const SelectedSortItemAlignedWithGroupName = css `
	${SelectedSortItem};
	padding-left: ${GROUP_NAME_PADDING_LEFT};
`;
export const SelectedListItem = css `
	background-color: ${Mi.menuItemSelectedBackgroundColor};
	color: ${Mi.menuItemSelectedColor};
	cursor: ${Mi.actionableCursor};
	position: relative;
	font-size: ${Mi.fontSize14};
`;
export const SelectedListItemAlignedWithGroupName = css `
	${SelectedListItem};
	padding-left: ${GROUP_NAME_PADDING_LEFT};
`;
export const DefaultListItem = css `
	cursor: ${Mi.actionableCursor};
	&:hover {
		background-color: ${Mi.menuItemBackgroundColorHoverFocus};
		color: ${Mi.baseFontColor};
	}
	position: relative;
	font-size: ${Mi.fontSize14};
`;
export const DefaultListItemAlignedWithGroupName = css `
	${DefaultListItem};
	padding-left: ${GROUP_NAME_PADDING_LEFT};
`;
export const DisabledListItem = css `
	cursor: default;
	background-color: ${Mi.colorNeutral10};
	border-color: ${Mi.colorNeutral30};
	color: ${Mi.colorNeutral30};
	font-size: ${Mi.fontSize14};
	user-select: none;
	pointer-events: none;
`;
export const DisabledListItemAlignedWithGroupName = css `
	${DisabledListItem};
	padding-left: ${GROUP_NAME_PADDING_LEFT};
`;
export const ButtonHoverStyle = css `
	background: ${Mi.colorTransparentBlack10};
`;
export const StyledSortItemDiv = styled('div') `
	text-align: right;
	user-select: none;
	cursor: ${Mi.actionableCursor};
`;
export const StyledPopoverContainer = styled(Grid) `
	border-radius: ${Mi.spacer04};
	box-shadow: ${Mi.boxShadow02};
	border: ${Mi.baseBorderWidth} ${Mi.baseBorderStyle} ${Mi.colorBrand50};
	padding: ${Mi.spacer04} 0 0 0;
`;
export const StyledCheckboxWrapper = styled('div') `
	width: 250px;
	word-break: break-word;
	display: flex;
	padding-left: ${Mi.spacer12};
	flex: 1;
`;
export const StyledLegendCircle = styled('span') `
	width: 12px;
	height: 12px;
	border-radius: 50%;
	background-color: ${props => props.legendColor || Mi.colorNeutral40};
	margin-right: ${Mi.spacer12};
	flex-shrink: 0;
	align-self: center;
`;
export const StyledFooter = css `
	background: ${Mi.colorNeutral20};
	border-top: ${Mi.baseBorderWidth} ${Mi.baseBorderStyle} ${Mi.colorNeutral30};
	border-bottom-right-radius: ${Mi.baseBorderRadius};
	border-bottom-left-radius: ${Mi.baseBorderRadius};
`;
export const StyledSearchBox = styled(Grid) `
	background: ${Mi.colorNeutral20};
	border-bottom: ${Mi.baseBorderWidth} ${Mi.baseBorderStyle} ${Mi.colorNeutral30};
	border-bottom-right-radius: ${Mi.baseBorderRadius};
	border-bottom-left-radius: ${Mi.baseBorderRadius};
	padding: ${Mi.spacer08};
	margin-top: -${Mi.spacer04};
`;
export const StyledStickyLabel = styled(Grid) `
	background: ${Mi.colorMocha10};
	padding: ${Mi.spacer08} 0 ${Mi.spacer08} ${Mi.spacer12};
	font-size: ${Mi.fontSize14};
	font-weight: ${Mi.fontWeightSemibold};
	position: sticky;
	top: 0;
	z-index: 2;
	flex: none;
`;
export const StyledAdditionalLabel = styled('span') `
	cursor: ${Mi.actionableCursor};
	&:hover {
		background-color: ${(props) => props.isSelected ? '' : Mi.menuItemBackgroundColorHoverFocus};
		color: ${(props) => (props.isSelected ? '' : Mi.baseFontColor)};
	}
	position: relative;
	font-size: ${Mi.fontSize14};
	padding: ${Mi.spacer12} 0 ${Mi.spacer12} ${Mi.spacer12};
	background: ${(props) => props.isSelected ? Mi.menuItemSelectedBackgroundColor : ''};
	color: ${(props) => (props.isSelected ? Mi.menuItemSelectedColor : '')};
`;
export const StyledStickyContainer = styled(Grid) `
	overflow: auto;
	max-height: ${(props) => props.issticky ? Mi.layoutBreakpointXs : 'none'};
	max-width: ${(props) => props.issticky ? Mi.layoutBreakpointXs : 'none'};
`;
export const StyledDropdownItem = styled(ListItem, {
    shouldForwardProp: (prop) => !['isHighlightListItem', 'highlightBackgroundColor'].includes(prop)
}) `
	background-color: ${({ isHighlightListItem, highlightBackgroundColor }) => isHighlightListItem ? highlightBackgroundColor || Mi.colorNeutral20 : ''};

	${({ isHighlightListItem }) => isHighlightListItem &&
    css `
			color: ${Mi.colorBlack};
		`}
	&:hover {
		background-color: ${Mi.menuItemBackgroundColorHoverFocus};
	}
`;
//# sourceMappingURL=DropdownList.style.js.map